import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yesNoBlank'
})
export class YesNoBlankPipe implements PipeTransform {

  transform(input: any, ...args: any[]): any {
    if (input == null) {
      return 'Not Supplied';
      }
    return input ? 'Yes' : 'No';
  }

}
